import { render, staticRenderFns } from "./List.vue?vue&type=template&id=15deb18d&scoped=true"
import script from "./List.ts?vue&type=script&lang=ts&external"
export * from "./List.ts?vue&type=script&lang=ts&external"
import style0 from "./List.vue?vue&type=style&index=0&id=15deb18d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15deb18d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src120839944/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15deb18d')) {
      api.createRecord('15deb18d', component.options)
    } else {
      api.reload('15deb18d', component.options)
    }
    module.hot.accept("./List.vue?vue&type=template&id=15deb18d&scoped=true", function () {
      api.rerender('15deb18d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/LOPD/pages/List/List.vue"
export default component.exports